import { createRouter, createWebHistory } from 'vue-router'
import Homepage from '@/views/homepage/index.vue'
import FunctionDetail from '@/views/homepage/functionDetail.vue'
import Contact from '@/views/contact.vue'
import PrivacyPage from '@/views/privacy.vue'
import ServicePage from '@/views/service.vue'

const routes = [
  {
    path: '/',
    redirect: '/homepage'
  },
  {
    path: '/homepage',
    name: 'Homepage',
    component: Homepage
  },
  {
    path: '/homepage/functions',
    name: 'FunctionDetail',
    component: FunctionDetail
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage
  },
  {
    path: '/service',
    name: 'Service',
    component: ServicePage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

